<template>
  <a-col :span="24">
    <p class="my-1 text-2x">รหัสผ่านต้องประกอบด้วย</p>
    <a-row :gutter="[16, 4]">
      <a-col
        v-for="(condition, i) in conditions"
        :key="'condition-password-' + i"
        :span="12"
        class="flex items-center"
      >
        <p class="inline-flex items-center gap-1 text-xl truncate">
          <span>
            <CheckCircleIcon
              :class="passwordStrength[i] ? 'text-crimson' : 'text-grey-2'"
              class="w-5"
            />
          </span>
          <span>{{ condition }}</span>
        </p>
      </a-col>
    </a-row>
  </a-col>
</template>

<script setup lang="ts">
import { regexPassword } from "@/configs/other";
import { CheckCircleIcon } from "@heroicons/vue/24/solid";
import { reactive, watch } from "vue";

const props = defineProps<{ password?: string }>();

const conditions = [
  "ตัวอักษรภาษาอังกฤษพิมพ์ใหญ่อย่างน้อย 1 ตัวอักษร",
  "ตัวเลขอย่างน้อย 1 ตัวเลข",
  "ตัวอักษรภาษาอังกฤษพิมพ์เล็กอย่างน้อย 1 ตัวอักษร",
  "รหัสผ่านต้องมีความยาวอย่างน้อย 8 ตัวอักษร",
];

const passwordStrength = reactive([false, false, false, false]);

const checkPasswordStrength = () => {
  passwordStrength[0] = props.password
    ? regexPassword.uppercase.test(props.password)
    : false;
  passwordStrength[1] = props.password
    ? regexPassword.digital.test(props.password)
    : false;
  passwordStrength[2] = props.password
    ? regexPassword.lowercase.test(props.password)
    : false;
  passwordStrength[3] = props.password ? props.password.length >= 8 : false;
};

watch(() => props.password, checkPasswordStrength, { deep: true });

checkPasswordStrength();
</script>
